import { Tabs, Tooltip } from "antd";
import React, { FC, useState } from "react";
import * as XLSX from 'xlsx';
import DrillDownViewTableForMonth from "../DrillDownViewTableForMonth/drillDownViewTableForMonth";

import "./DrillDownViewForMonth.scss";
import DownloadReport from "@assets/DownloadReport.svg";
import { forEach } from "lodash";

const DrillDownViewForMonth: FC<any> = ({activeTabKey, callback}) => {
    
    const { TabPane } = Tabs;
    const [monthlyAppointmentDetails, setMonthlyAppointmentDetails] = useState();
    const tabsConfig = {
        "Appointments Info": true
    }

    const onTabChange = (key:any) => {
        callback(key)
    }

    const generateReport = () => {
        let data:any;
        let fileName="";
        if(activeTabKey === 1){ data=monthlyAppointmentDetails;fileName="Monthly Appointment Information"}
    
        let reportObj:any = [];
        forEach(data , (item)=>{
          let tempObject:any = {}
          forEach(item, (itemEntries)=>{
            tempObject[ itemEntries.label.includes("AMOUNT")? `${itemEntries.label} (in US Dollars)` : itemEntries.label]= itemEntries.label.includes("AMOUNT")? Number(itemEntries.value) : itemEntries.value;
          })
          reportObj.push(tempObject);
        })
        if(reportObj.length > 0){
          const fileLabel = `${fileName}.xlsx`;
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(reportObj);
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, fileName);
          XLSX.writeFile(wb, fileLabel);
        }
      }

    const operations = (
        <Tooltip title="Download XLS" overlayClassName="download-tooltip" className="downloadReportForPatient">
          <img alt="" src={DownloadReport} className="downloadReportForPatient__downloadIcon" onClick={generateReport}/>
        </Tooltip>
      );
    
    return (
        <div className="dayViewAppointmentReports">
            <Tabs activeKey={activeTabKey} defaultActiveKey="1" className="tab-menu" onChange={onTabChange} tabBarExtraContent={operations}>
                {tabsConfig["Appointments Info"] && (
                    <TabPane tab={`Appointment Info`} key="1">
                        <DrillDownViewTableForMonth setMonthlyAppointmentDetails={setMonthlyAppointmentDetails}/>
                    </TabPane>
                )}
            </Tabs>
        </div>
    )
}

export default DrillDownViewForMonth;